import React from 'react';
import { ShareQuotationInput } from './contracts';
import { useShareQuotation } from '../../hooks/useShareQuotation';

type ShareQuotationButtonProps = ShareQuotationInput & {
  label: string;
  className?: string;
};

const ShareQuotationButton: React.FC<ShareQuotationButtonProps> = ({
  label,
  className = 'package-editor-btn-primary',
  ...shareInput
}) => {
  const { canShare, isSharing, share } = useShareQuotation(shareInput);

  return (
    <button type="button" onClick={share} disabled={!canShare} className={className}>
      {isSharing ? (shareInput.download && !shareInput.shareDraft ? 'Downloading…' : 'Sharing…') : label}
    </button>
  );
};

export default ShareQuotationButton;
